import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { addToCart } from "../action"
import Header from "../component/Header";
import Footer from "../component/Footer"
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../action"
import axios from "../helper/axios"
import { getSkuPriceData, resolveDiscount } from "../helper/discount"

export default function Wishlist() {
  const dispatch = useDispatch();
  const wishlistItems = useSelector(state => state.cart?.wishlistItems)
  const [clicking, setClicking] = useState();
  const [qty, setQty] = useState(1);
  const [isAlertVisible, setIsAlertVisible] = React.useState(false);

  const cartData = useSelector(state => state.cart?.cartItems);

  // Fetch fresh product data for all wishlist items on mount/refresh
  useEffect(() => {
    const fetchFreshWishlistData = async () => {
      if (!wishlistItems || wishlistItems.length === 0) return;

      try {
        // Fetch fresh data for all wishlist items in parallel
        const freshDataPromises = wishlistItems.map(async (item) => {
          try {
            const dataId = { _id: item?.externalId || item?._id };
            const res = await axios.post("/getproductbyid", dataId);
            
            if (res?.data?.length > 0) {
              // Return the fresh product details
              return res.data[0]?.productDetails || item; // Fallback to original item if structure is different
            }
            return item; // Return original item if fetch fails
          } catch (error) {
            console.error(`Error fetching product ${item?._id}:`, error);
            return item; // Return original item on error
          }
        });

        const freshWishlistData = await Promise.all(freshDataPromises);
        
        // Only update if we got different data (to avoid unnecessary updates)
        const hasChanges = freshWishlistData.some((freshItem, index) => {
          const oldItem = wishlistItems[index];
          return JSON.stringify(freshItem?.variants) !== JSON.stringify(oldItem?.variants);
        });

        if (hasChanges) {
          dispatch(addToWishlist(freshWishlistData));
        }
      } catch (error) {
        console.error("Error refreshing wishlist data:", error);
      }
    };

    fetchFreshWishlistData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount - intentionally empty to fetch fresh data on page load/refresh

  const addItemToWishlist = async (res) => {
    setClicking(Math.random());

    if (!wishlistItems) {
        dispatch(addToWishlist([res]));
        return;
    }

    const index = wishlistItems.findIndex(x => x?._id === res?._id);
    let newWishlist;

    if (index === -1) {
        // Shto produktin
        newWishlist = [...wishlistItems, res];
    } else {
        // Heq produktin
        newWishlist = wishlistItems.filter(x => x?._id !== res?._id);
    }

    dispatch(addToWishlist(newWishlist));
}

  

  const onQuantityIncrement = () => {
    setQty(qty + 1);
  };

  const onQuantityDecrement = () => {
    if (qty <= 1) return;
    setQty(qty - 1);
  };

// OLD CODE 
  // const addToCartData = (productInfo) => {
  //   var selectedSize = 11
  //   productInfo.size = selectedSize;
  //   if (cartData.length > 0) {
  //     var foundIndex = cartData.findIndex(element => element?._id === productInfo?._id);
  //   } else {
  //     productInfo.quantity = qty;
  //     var foundIndex = -1;
  //   }
  //   if (foundIndex < 0) {
  //     productInfo.quantity = qty;
  //     cartData.push(productInfo);
  //   } else {
  //     cartData[foundIndex].quantity = parseInt(cartData[foundIndex].quantity) + parseInt(qty);
  //   }

  //   dispatch(addToCart(cartData))
  //   setIsAlertVisible(true);
  //   setTimeout(() => {
  //     setIsAlertVisible(false);
  //   }, 2000);

  // }


  // NEW CODE

  const addToCartData = (productInfo) => {
    var selectedSize = 11;
    const newProduct = { ...productInfo, size: selectedSize, quantity: qty }; // krijojmë kopje të produktit
    let newCart;

    const foundIndex = cartData.findIndex(element => element?._id === newProduct._id);

    if (foundIndex < 0) {
        // Shto produktin e ri
        newCart = [...cartData, newProduct];
    } else {
        // Rrit sasinë në një copy të cartData
        newCart = cartData.map((item, idx) =>
            idx === foundIndex
                ? { ...item, quantity: parseInt(item.quantity) + parseInt(qty) }
                : item
        );
    }

    dispatch(addToCart(newCart));
    setIsAlertVisible(true);
    setTimeout(() => setIsAlertVisible(false), 2000);
}




  return (
    <>
      <Header />

      <div className="container mx-auto px-4 py-10 main_wish_list mb-20 mt-10 ">
        <div className="flex items-center justify-center mb-8 border-b pb-4">
          <h1 className="text-3xl font-bold flex items-center gap-2">
            Dëshira
            <span className="text-red-500 text-2xl">❤️</span>
          </h1>
        </div>

        {wishlistItems && wishlistItems.length > 0 ? (
          <div className="space-y-4">
            {wishlistItems.map((dtt, i) => {
              const variantData = dtt?.variants?.[0];
              const price = variantData?.sizes?.[0]?.skus[0] || {};
              const ImageUrl = process.env.REACT_APP_IMAGE_URL + variantData?.newImagesUrl?.[0];

              return (
                <div
                  key={i}
                  className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-white rounded border shadow-sm p-4 hover:shadow-md transition"
                >
                  {/* Image + Details Wrapper */}
                  <div className="flex flex-col sm:flex-row w-full sm:w-11/12">
                    {/* Image */}
                    <div className="w-full sm:w-1/5 mb-4 sm:mb-0">
                      <Link 
                        to={`/productdetails/${dtt?.externalId}/${dtt?.categories?.[0]}`}
                      >
                        <img
                          src={ImageUrl}
                          alt={dtt?.name}
                          className="w-full h-36 object-contain"
                        />
                      </Link>
                    </div>

                    {/* Details */}
                    <div className="w-full sm:w-4/5 px-0 sm:px-4">
                    <Link 
                        to={`/productdetails/${dtt?.externalId}/${dtt?.categories?.[0]}`}
                        className="block"
                      >
                        <h3 className="font-semibold text-lg line-clamp-2 hover:text-yellow-500 transition-colors cursor-pointer">{dtt?.name}</h3>
                      </Link>
                      <div className="text-sm text-gray-500 mt-1">Size: {price?.size || 'N/A'}</div>
                      <div className="mt-2 flex gap-3 items-center">
                        {(() => {
                          const { regular, sale, hasDiscount, hasDiscount2, activePrice } = resolveDiscount(getSkuPriceData(price));
                          if (hasDiscount) {
                            return (
                              <>
                                <span className="line-through text-gray-400 text-sm">{regular.toFixed(2)}€</span>
                                {hasDiscount2 && (
                                  <span className="line-through text-gray-400 text-sm">{sale.toFixed(2)}€</span>
                                )}
                                <span className="text-lg font-semibold text-red-600">{activePrice.toFixed(2)}€</span>
                              </>
                            );
                          }
                          return <span className="text-lg text-green-600 font-semibold">{regular.toFixed(2)}€</span>;
                        })()}
                      </div>
                    </div>
                  </div>

                  {/* Delete Button */}
                  <div className="w-full sm:w-auto flex justify-end mt-4 sm:mt-0">
                    <button
                      className="rounded-full bg-red-500 flex items-center justify-center hover:bg-red-600 transition"
                      onClick={() => addItemToWishlist(dtt)}
                    >
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="#fff">
                        <circle cx="9" cy="9" r="9" fill="#ff0000" />
                        <g transform="translate(5.77 6.115)">
                          <line x1="6" y2="6" stroke="#fff" strokeWidth="1" />
                          <line x2="6" y2="6" stroke="#fff" strokeWidth="1" />
                        </g>
                      </svg>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

        ) : (
          <div className="text-center mt-10">
            <h2 className="text-2xl font-semibold mb-2">Lista ime</h2>
            <p className="text-gray-600 mb-5">Ju momentalisht nuk keni ndonjë produkt në listë</p>
            <Link to="/">
              <button className="border border-gray-500 px-6 py-2 rounded hover:bg-black hover:text-white transition">
                Shto produkte
              </button>
            </Link>
          </div>
        )}
      </div>



      <Footer />
    </>
  )
}